<template>
  <UiLink
    ref="el"
    class="relative flex h-full w-full justify-center overflow-hidden rounded-md bg-white text-center"
    :to="link"
  >
    <template v-if="text">
      <span class="relative z-[1] flex flex-col items-center text-center">
        <span
          v-if="title"
          class="title uppercase leading-none text-slate"
          :class="titleClasses"
          v-html="title"
        />

        <span
          class="mt-2 text-sm leading-[1.225rem] text-slate md:whitespace-pre-line"
          v-html="text"
        />
      </span>
    </template>

    <span
      v-else-if="title"
      class="title relative z-[1] text-center uppercase leading-none"
      :class="titleClasses"
      v-html="title"
    />

    <CatalogCategoryItemImages
      :image="image"
      :images="images"
      :styles="styles"
      :is-mobile="!isDesktop"
      :is-hover="hover"
    />
  </UiLink>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useElementHover } from '@vueuse/core';
import { useBreakpoint } from '~/composables';
import CatalogCategoryItemImages from '~/components/sections/categorySection/CatalogCategoryItemImages.vue';

const variations: Record<string, { [key: string]: string }> = {
  title: {
    default: 'tracking-[0.12em] text-xs text-slate sm:text-sm 2xl:text-lg',
    catalog: 'text-xl md:text-3xl',
  },
};
interface Props {
  link?: string;
  title?: string;
  text?: string;
  image?: any;
  images?: any;
  styles?: any;
  variation?: string;
}

const props = withDefaults(defineProps<Props>(), {
  link: '',
  title: '',
  text: '',
  image: () => ({}),
  images: () => ({}),
  styles: () => ({}),
  variation: '',
});

const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');
const el = ref();
const hover = useElementHover(el as any);

const titleClasses = computed(() => variations.title[props.variation]);
</script>
